<div
  #customTooltip
  class="tooltip"
  [style.left]="left + 'px'"
  [style.top]="top + 'px'"
  [style.min-width]="minWidth"
  [style.max-width]="maxWidth"
  [class.visible]="visible"
>
  <ng-container *ngIf="template; else htmlMode">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </ng-container>

  <ng-template #htmlMode>
    <div [innerHTML]="tooltip"></div>
  </ng-template>
</div>
